import React, { useContext } from 'react';
import { Container, Grid } from 'semantic-ui-react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { LargeMonitorContext } from '../context';
import { toSnakeCase } from '../helpers/common';
import LineyLesson from './LineyLesson';

const HeroIntro = (props) => {
  const { anchorTagLinkText, image, liney_lesson_content, heading, emphasised_message, intro, heading_class } = props;

  const largeMonitorContext = useContext(LargeMonitorContext);

  return (
    <header className="hero-intro" id={anchorTagLinkText && `${toSnakeCase(anchorTagLinkText)}`}>
      {image && (
        <GatsbyImage
          className="hero-intro__image page-banner"
          image={image.localFile?.childImageSharp?.gatsbyImageData}
          alt=""
          backgroundColor={`#fff`}
        />
      )}
      <Container className="hero-intro__container">
        <Grid>
          <Grid.Row>
            {largeMonitorContext && <Grid.Column width={1}></Grid.Column>}
            <Grid.Column mobile={12} tablet={11} computer={8}>
              <div className="hero-intro__content">
                {heading && (
                  <h2 className={`hero-intro__heading hero-intro__heading-accent${heading_class ? ' ' + heading_class : ''}`}>{heading}</h2>
                )}
                {emphasised_message && <p className="page-leader__emphasised-message">{emphasised_message}</p>}
                {intro && <div dangerouslySetInnerHTML={{ __html: intro }} />}
                {liney_lesson_content === 'true' && <LineyLesson />}
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </header>
  );
};

export default HeroIntro;
